import {
  ArrowDownTrayIcon,
  CheckCircleIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';

import { cn } from '@/lib/utils';
import type { HipaaPackageSchema } from '@/services/api/hipaaPackageService';

interface HipaaPackageStatusProps {
  packageData: HipaaPackageSchema;
  className?: string;
}

/**
 * Displays the status of an available HIPAA package with download option.
 * Clean, minimal design showing package readiness.
 */
export const HipaaPackageStatus = ({
  packageData,
  className,
}: HipaaPackageStatusProps) => {
  const downloadUrl =
    packageData.rendered_pdf_url ||
    packageData.download_url ||
    packageData.manually_uploaded_url;

  const handleDownload = () => {
    if (downloadUrl) {
      window.open(downloadUrl, '_blank');
    }
  };

  return (
    <div
      className={cn(
        'rounded-xl border border-zinc-200 bg-zinc-50/50 p-4',
        className,
      )}
    >
      <div className="flex items-center gap-3">
        {/* Document icon with check */}
        <div className="relative flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-50">
          <DocumentTextIcon className="h-5 w-5 text-emerald-600" />
          <CheckCircleIcon className="absolute -bottom-1 -right-1 h-4 w-4 text-emerald-500 bg-white rounded-full" />
        </div>

        {/* Package info */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-zinc-900">
            HIPAA Package Ready
          </p>
          <p className="text-xs text-zinc-500">
            Will be attached automatically
          </p>
        </div>

        {/* Download action */}
        {downloadUrl && (
          <button
            type="button"
            onClick={handleDownload}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 rounded-lg transition-colors"
          >
            <ArrowDownTrayIcon className="h-4 w-4" />
            <span>View</span>
          </button>
        )}
      </div>
    </div>
  );
};
